import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"];
import { createContext, useContext } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const BoardCoreDataContext = /*#__PURE__*/createContext(null);
export const BoardCoreDataProvider = _ref => {
  let {
      children
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(BoardCoreDataContext.Provider, {
    value: props,
    children: children
  });
};
export const useBoardCoreData = () => {
  const props = useContext(BoardCoreDataContext);
  if (!props) {
    throw new Error('BoardCoreDataProvider not found');
  }
  return props;
};